export * from '../src/composites/wui-notice-card/index.js';
//# sourceMappingURL=wui-notice-card.js.map